import Layout from "@/components/feature/Layout";
import { usePageMeta } from "@/hooks/usePageMeta";
import CategoryShell from "@/components/feature/CategoryShell";
import NewsCard from "@/components/base/NewsCard";
import Pagination from "@/components/base/Pagination";
import EmptyState from "@/components/base/EmptyState";
import { useCategoryFilter } from "@/hooks/useCategoryFilter";
import { newsList } from "@/mocks/news";
import type { NewsItem } from "@/types";

const filterGroups = [
  {
    key: "category",
    title: "按分类",
    options: [
      "新番情报",
      "业界动态",
      "深度访谈",
      "周边资讯",
      "演出活动",
      "联动活动",
      "音乐情报",
      "漫展现场",
      "创作手记",
    ],
  },
];

const sortOptions = [
  {
    label: "最新",
    compare: (a: NewsItem, b: NewsItem) =>
      new Date(b.publishTime).getTime() - new Date(a.publishTime).getTime(),
  },
  { label: "热门", compare: (a: NewsItem, b: NewsItem) => b.views - a.views },
];

export default function NewsCategoryPage() {
  usePageMeta({
    title: "动漫新闻 - 风车动漫网",
    description:
      "风车动漫网动漫新闻频道聚合新番情报、业界动态、周边活动与深度访谈，支持按分类筛选，帮助你第一时间掌握动漫圈动态。",
    keywords: "动漫新闻,新番情报,业界动态,风车动漫网",
  });

  const state = useCategoryFilter<NewsItem>(
    newsList,
    (news) => ({ category: [news.category] }),
    sortOptions,
    6,
  );

  return (
    <Layout>
      <CategoryShell
        crumbs={[{ label: "动漫新闻" }]}
        eyebrow="Anime News"
        title="动漫新闻"
        icon="ri-newspaper-line"
        description="最新新番情报、业界动态、周边活动与深度访谈，带你第一时间掌握动漫圈的大小事。"
        filterGroups={filterGroups}
        selected={state.selected}
        onToggle={state.toggle}
        onReset={state.reset}
        sortOptions={sortOptions.map((option) => option.label)}
        sort={state.sort}
        onSort={state.setSort}
        resultLabel={`共 ${state.total} 条新闻`}
      >
        {state.total === 0 ? (
          <EmptyState
            title="没有找到相关新闻"
            description="换个分类试试，或重置筛选查看全部新闻资讯。"
            action={
              <button
                type="button"
                onClick={state.reset}
                className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                重置筛选
              </button>
            }
          />
        ) : (
          <>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              {state.pageItems.map((news) => (
                <NewsCard key={news.id} news={news} />
              ))}
            </div>
            <Pagination current={state.page} total={state.totalPages} onChange={state.setPage} />
          </>
        )}
      </CategoryShell>
    </Layout>
  );
}